import React, { useContext } from 'react'
import { Box, ImageLoader, Text } from '@usap/uicomponents'
import { SelectedItemsContext } from '../../contexts/SelectedItemsContextProvider'

export default function ReturnStatus({
  returnStatusData,
  setDisplayReturnDetails,
  setReturnDetailsData,
}) {
  const selectedItemsContextData = useContext(SelectedItemsContext)
  const {
    orderItems,
    setOrderItems,
  } = selectedItemsContextData

  const {
    message,
    returnRequestId,
    rmaId,
    merchantOrderId,
    creditId,
    email,
    orderId,
    orderItemId,
    imagesData = [],
  } = returnStatusData

  let idNumber = returnRequestId
  let idType = 'Return Request ID'

  if (creditId) {
    idNumber = creditId
    idType = 'Credit ID'
  }

  if (rmaId && rmaId !== 'GP RMA not received.') {
    idNumber = rmaId
    idType = 'RMA ID'
  }

  if (!returnRequestId && !rmaId && !creditId) return null

  const triggerReturnDetailsDisplay = () => {
    const dataReturn = {
      returnRequestId,
      merchantOrderId,
      orderId,
      orderItemId,
      rmaId,
      creditId,
      email,
    }
    if (orderItems && orderItems.length) setOrderItems([])
    setDisplayReturnDetails(true)
    setReturnDetailsData(dataReturn)
  }

  const displayImages = () => Array.isArray(imagesData) && imagesData.map(data => (
    <Box
      key={data.sku_title}
      width="70px"
      pad="xsmall"
      background={{ color: '#FFFFFF' }}
      round="small"
    >
      <ImageLoader
        fit="contain"
        alt={data.sku_title}
        src={data.ImageURL}
        width="100%"
        height="100%"
        cloudinaryParams="w_100,h_80"
      />
    </Box>
  ))

  return (
    <Box
      background={{ color: '#EEF4FC' }}
      pad={{ vertical: '12px', horizontal: '16px' }}
    >
      <Text
        color="dark-2"
        size="medium"
        weight="bold"
      >
        { message }
      </Text>
      <Text size="xsmall">
        { idType }
        :
        &nbsp;
        <strong>{ idNumber }</strong>
      </Text>
      <Box
        gap="small"
        direction="row"
        margin={{ vertical: '12pt' }}
      >
        { displayImages() }
      </Box>
      <Box onClick={triggerReturnDetailsDisplay}>
        <Text
          color="#05629B"
          size="small"
          alignSelf="center"
        >
          See Return Details &gt;
        </Text>
      </Box>
    </Box>
  )
}
